import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class JoinLabel extends BaseOption {
  static userInterfaceComponent = {
    label: "Join button text",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Join call";
}
